import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Box,
  Tooltip,
  Badge,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FavoriteIcon from "@mui/icons-material/Favorite";
import UserProfile from "../Buttons/UserProfile";
import { FETCH_CART } from "../../graphql/queries";
import { useLazyQuery } from "@apollo/client";
import useLocalStorage from "../Hooks/LocalStorage";
import { Cart } from "../../graphql/generated";

const shareStockLogo = require('../../assets/images/ShareStockLogo.png')


const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#000",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));


const NavigationBar: React.FC = () => {
  const cartId = useLocalStorage('shopifyCartId');
  console.log("CART ID in navigationBAR:", cartId)
  const [fetchCart, { data }] = useLazyQuery(FETCH_CART);
  const [cartQuantity, setCartQuantity] = useState<Number>(0);

  // const [fetchCart, { _loading, data, _error }] = useLazyQuery(FETCH_CART);

  // Fetch cart whenever cartId is available
  useEffect(() => {
    if (cartId) {
      fetchCart({ variables: { cartId } });
    }
  }, [cartId, fetchCart]);

  // if (loading) return <p>Loading cart...</p>;
  // if (error) return <p>Error fetching cart: {error.message}</p>;
  // if (!data) return <p>No cart data found</p>;

  const cart = data?.fetchCart || "";

  useEffect(() => {
    console.log("Cart: ", cart || "")
  }, [cart])

      // Function to calculate total quantity in the cart
  const calculateCartQuantity = (cart: Cart) => {
    if (!cart || !cart.lines) return 0;
    return cart.lines.reduce((sum, line) => sum + line.quantity, 0);
  };

    // Update cart quantity whenever cart data changes
  useEffect(() => {
    if (data?.fetchCart) {
      const totalQuantity = calculateCartQuantity(data.fetchCart);
      setCartQuantity(totalQuantity);
    }
  }, [data]);

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#F8E3F5"  }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        {/* Navigation Links */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" }, // Flexbox for layout
            gap: 6, // Evenly spaces the children
            alignItems: "center", // Aligns children vertically in the center
          }}
        >
          <Typography variant="overline" noWrap component={Link} to="/browse" sx={{ textDecoration: "none", color: "#000" }}>
            WOMENSWEAR
          </Typography>
          <Typography variant="overline" noWrap component={Link} to="/browse" sx={{ textDecoration: "none", color: "#000" }}>
            MENSWEAR
          </Typography>
          <Typography variant="overline" noWrap component={Link} to="/browse" sx={{ textDecoration: "none", color: "#000" }}>
            LIFESTYLE
          </Typography>
          <Typography variant="overline" noWrap component={Link} to="/browse" sx={{ textDecoration: "none", color: "#000" }}>
            KIDS
          </Typography>
        </Box>
        {/* Spacer to push icons to the right */}
        <Box sx={{ flexGrow: 1 }} />
        {/* Logo and Title */}
        <Box
          component={Link} // Makes the entire box a link
          to="/landing" // Redirects to "/landing" on click
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            paddingRight: 2,
            textDecoration: "none", // Removes underline on the link
            color: "inherit", // Inherit color to prevent styling issues
            cursor: "pointer", // Adds a pointer cursor for the box
          }}
        >
          <Box
                component="img"
                src={shareStockLogo}
                alt="Logo"
                sx={{
                  width: "100%", // Set width
                  height: "100%", // Maintain aspect ratio
                  maxWidth: "260px",
                  m: 1
                }}
              />
          {/* <ShareStockLogo size={60} />
          <Box flexDirection={"column"} alignItems={"flex-start"} display={"flex"}>
            <Typography
              variant="h4"
              noWrap
              sx={{ flexGrow: 1, color: "#000" }} // Apply color here for consistency
            >
              ShareStock
            </Typography>
            <Typography
              variant="subtitle2"
              noWrap
              sx={{ flexGrow: 1, color: "#000", mt: -1 }} // Apply color here for consistency
            >
              Inventory Sharing App
            </Typography>
          </Box> */}
          
        </Box>
        {/* Spacer to push icons to the right */}
        <Box sx={{ flexGrow: 1 }} />
        {/* Search Bar */}
        <Search
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ccc", // Outlined border
            borderRadius: "4px", // Rounded corners
            backgroundColor: "#fff", // White background
            padding: "2px 4px", // Inner padding for spacing
            flexGrow: 1, // Adjust width as needed
            "&:hover": {
              borderColor: "#999", // Darker border on hover
            },
            minWidth: "280px",
          }}
        >
          <SearchIconWrapper>
            <SearchIcon sx={{ color: "#000" }} /> {/* Black search icon */}
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ "aria-label": "search" }}
            sx={{
              color: "#000", // Black text
              width: "100%", // Take full width of the container
            }}
          />
        </Search>
        {/* Spacer to push icons to the right */}
        <Box sx={{ flexGrow: 1 }} />
        {/* Icons */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

          <Typography
            variant="overline"
            noWrap
            component={Link}
            to="/my-biz/my-listings"
            sx={{ textDecoration: "none", color: "#000", mr: 2 }}
          >
            MY BIZ
          </Typography>
          <IconButton href="/cart" aria-label="show cart items" color="inherit" sx={{ color: "#000" }}>
            <Badge badgeContent={cartQuantity as any} color="error">
              <ShoppingCartIcon />
            </Badge>
          </IconButton>
          <Tooltip title="Coming soon" arrow>
            <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
              
            <IconButton aria-label="show favorite items" color="inherit" sx={{ color: "#000" }} disabled>
              <FavoriteIcon />
            </IconButton>
            </Box>
          </Tooltip>
          <UserProfile />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
